/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook useUpdateProvider
 */
import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { getProviderPath } from 'utils/router';
import { invalidateMetadata } from 'app-constants/queryKeys';
import { prepareProviderUpdateModel } from 'utils/admin/providers';

interface IProps {
	providerId: string;
	model: Provider.IUpdateModel;
}

/**
 * Mutate for update Provider
 *
 */
const useUpdateProvider = (disableRedirect?: boolean): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ providerId, model }) => {
			await api.ProvidersApi.patchProvider({ providerId, providerPatchModel: prepareProviderUpdateModel(providerId, model) });
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
			if (!disableRedirect) {
				AppEvents.publishRedirect({ url: getProviderPath() });
			}
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateProvider;
